import { Download } from "lucide-react";

const STEPS = [
  "Download the extension folder using the button below.",
  "Unzip it on your computer.",
  "Open chrome://extensions in Chrome (or any Chromium browser).",
  "Toggle Developer mode ON in the top-right.",
  "Click 'Load unpacked' and select the unzipped extension folder.",
  "Pin WallGard for one-click verdicts on every site you visit.",
];

export default function Install() {
  const backend = process.env.REACT_APP_BACKEND_URL;
  return (
    <div className="max-w-[1100px] mx-auto px-6 py-10">
      <div className="text-[10px] tracking-[0.3em] uppercase text-neutral-500">Deployment</div>
      <h1 className="text-4xl md:text-5xl font-black uppercase tracking-tighter" style={{ fontFamily: "'Clash Display'" }}>Install Extension</h1>

      <div className="mt-8 grid md:grid-cols-2 gap-0 border-2 border-black">
        <div className="p-6 border-r-0 md:border-r-2 border-black border-b-2 md:border-b-0">
          <div className="text-[10px] tracking-[0.3em] uppercase text-neutral-500">Step by step</div>
          <ol className="mt-4 space-y-3">
            {STEPS.map((t, i) => (
              <li key={i} className="flex gap-4">
                <span className="w-7 h-7 bg-black text-white flex items-center justify-center text-xs font-bold flex-shrink-0">{i + 1}</span>
                <span className="text-sm">{t}</span>
              </li>
            ))}
          </ol>
        </div>
        <div className="p-6">
          <div className="text-[10px] tracking-[0.3em] uppercase text-neutral-500">Download</div>
          <p className="mt-2 text-sm">The extension is pre-configured to use this backend:</p>
          <code className="mt-2 block font-mono text-xs bg-neutral-100 border-2 border-black px-3 py-2 break-all" data-testid="install-backend-url">{backend}</code>
          <a href="/extension/wallgard-extension.zip" className="brutal-btn mt-6" data-testid="download-extension-btn">
            <Download size={14} /> Download .zip
          </a>
          <p className="mt-4 text-xs text-neutral-500">
            Source files also live at <code>/app/extension</code> in the project repo.
          </p>
        </div>
      </div>

      <div className="mt-10 brutal-card p-6">
        <div className="text-[10px] tracking-[0.3em] uppercase text-neutral-500">What it does</div>
        <ul className="mt-3 text-sm space-y-2 list-disc pl-5">
          <li>Scans every page you load and shows a green / yellow / red verdict in the toolbar.</li>
          <li>For dangerous sites it injects a full-page warning overlay before you interact.</li>
          <li>Every scan is logged in your dashboard for review and audit.</li>
        </ul>
      </div>
    </div>
  );
}
